<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      line-form
      unit="模具使用记录"
      edit-title
      id-key="Id"
      @opened="onOpened"
      :data="data"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @closed="toClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="模具编码" prop="mjbm">
              <el-select v-model="data.mjbm" placeholder="请选择模具编码">
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="内腔规格" prop="nqgg">
              <el-input v-model="data.nqgg" placeholder="根据模具编码自动带入" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="lx">
              <el-input v-model="data.nqgg" placeholder="根据模具编码自动带入" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作类型" prop="czlx">
              <el-select v-model="data.czlx">
                <el-option :value="0" label="领用"></el-option>
                <el-option :value="1" label="生产归还"></el-option>
                <el-option :value="2" label="归还客户"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作时间" prop="czsj">
              <el-date-picker
                v-model="data.czsj"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="相关人员" prop="xgry">
              <el-input v-model="data.xgry" placeholder="点击弹窗选择人员" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {
        Id: 0,
        mjbm: "",
        nqgg: "",
        lx: null,
        czlx: null,
        czsj: null,
        xgry: "",
      },
      api: require('@/api/ba/mould').default,
      rules: {
        mjbm: [{ required: true, message: '模具编码不能为空' }],
        // nqgg: [{ required: true, message: '内腔规格不能为空' }],
        // lx: [{ required: true, message: '类型不能为空' }],
        czlx: [{ required: true, message: '操作类型不能为空' }],
        czsj: [{ required: true, message: '操作时间不能为空' }],
        xgry: [{ required: true, message: '相关人员不能为空' }],
      },
    }
  },
  methods: {
    onOpened() {
      
    },
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {

    },
    onBeforeSave() {
      
    },
    toSave() {

    },
    toClosed() {
    },
  }
}
</script>
